import {line, drawPolyline,drawDot} from "@/components/cyphers/helpers/drawSvg";

const Width = 100;
const Height = Width;
const Padding = 5;
const lengthStepCount = 5.5;
const angleRamdomnesModificator = 5;
const lengthRamdomnesModificator = 5;


export function drawChar(canvas, charCoord, width=Width,height=Height,padding=Padding){
    let hSlots = [0,1,2,3,4];
    let vSlots = [0,1,2,3,4];
    if(charCoord[0]+charCoord[1]<5 && (charCoord[0] <=2&&charCoord[1] <=2)){
        hSlots = [1,2];
        vSlots = [1,2];
    }else if(charCoord[0]+charCoord[1]<5){
        hSlots = [1,2,3];
        vSlots = [1,2,3];
    }
    let slots=[hSlots,vSlots];
    let widthLength = width/lengthStepCount;
    let heightLength = height/lengthStepCount;
    if(charCoord[0]+charCoord[1]<3){
        widthLength = (width/lengthStepCount)*1.8;
        heightLength = (height/lengthStepCount)*1.8;
    }
    for(let i=0;i<2;i++){
        let linesCount = charCoord[i];
        // for(let linesCount of charCoords){//horizontal,vertical
        let toRemoveCounte = slots[i].length-linesCount
            for(let j=0; j < toRemoveCounte; j++){
                slots[i].splice(Math.floor(Math.random()*slots[i].length), 1);
            }
        let randomnes = Math.max(widthLength,heightLength)/angleRamdomnesModificator;
        let lenRandomnes = Math.max(widthLength,heightLength)/lengthRamdomnesModificator;
            for(let lineslot of slots[i]){
                let currRandomnes  = Math.floor(Math.random() * 3 * lenRandomnes)-lenRandomnes;// 0; //
                let currRandomnes0 = Math.floor(Math.random() * 2 * randomnes)-randomnes;// 0; //
                let currRandomnes1 = Math.floor(Math.random() * 2 * randomnes)-randomnes;// 0; //
                if (i == 1) {
                    //vertical
                    // let currLen = Math.max(2*widthLength, (Math.floor(Math.random() * 5) * widthLength)) + currRandomnes;
                    let currLen = Math.min(2*widthLength + currRandomnes,(Math.floor(Math.random() * 5) * widthLength) + currRandomnes);
                    let fx = padding + width - currLen + currRandomnes;
                    // let fx = padding  - currLen+ currRandomnes;
                    let fy = padding + lineslot * heightLength + currRandomnes0;
                    currRandomnes  = Math.ceil(Math.random() * 2 * lenRandomnes)-lenRandomnes;// 0; //
                    let tx = padding + currLen - currRandomnes;
                    let ty = padding + lineslot * heightLength + currRandomnes1;
                    line(canvas, fx, fy, tx, ty)
                } else {
                    //horizontal
                    // let currLen = Math.max(2*heightLength, (Math.floor(Math.random() * 5) * heightLength)) + currRandomnes;
                    let currLen = Math.min(2*heightLength+ currRandomnes, (Math.floor(Math.random() * 5) * heightLength) + currRandomnes);
                    let fx = padding + lineslot * widthLength + currRandomnes0
                    let fy = padding + height - currLen+ currRandomnes
                    // let fy = padding + - currLen+ currRandomnes
                    currRandomnes  = Math.ceil(Math.random() * 2 * lenRandomnes)-lenRandomnes;// 0; //
                    let tx = padding + lineslot * widthLength + currRandomnes1
                    let ty = padding + currLen - currRandomnes
                    line(canvas, fx, fy, tx, ty)
                }
            }


        // }
    }

    // drawPolyline(canvas, CharPaths(width, height, padding)[(charNumber%9)], 3)
    // drawDot(canvas, padding+(height/2),padding+(width/2),padding, (charNumber/9>>0) )


}